export const GET_CANDIDATESTATUSS = "GET_CANDIDATESTATUSS";
export const ADD_CANDIDATESTATUS = "ADD_CANDIDATESTATUS";
export const EDIT_CANDIDATESTATUS = "EDIT_CANDIDATESTATUS";
export const GET_CANDIDATESTATUS = "GET_CANDIDATESTATUS";
export const RESET_CANDIDATESTATUS = "RESET_CANDIDATESTATUS";
export const ERROR_CANDIDATESTATUS = "ERROR_CANDIDATESTATUS";
export const GET_ALL_CANDIDATESTATUSS = "GET_ALL_CANDIDATESTATUSS";
                